import SearchInput from "./fields/SearchInput";
import PublicService from '../services/PublicService';


function SchoolSearch({ school, validationError, onChange, canModifyDetails }) {
    return (
        <SearchInput
            name="school"
            label="Search School"
            placeholder={`Type and select from the list`}
            getOptions={PublicService.fetchSchoolsByQuery}
            validationError={validationError}
            value={school}
            onChange={onChange}
            canModifyDetails={canModifyDetails}
        />
    )
}

export default SchoolSearch;
